export default __webpack_public_path__ + "static/media/preview.a01e6477.png";